import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/UsefulMaterialsModule/UsefulMaterialsModule.tsx");
